<router-outlet> </router-outlet>
<div *ngIf="isDevMode" class="version">version {{ version }}</div>
